import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { Routes } from "../../routes";
import { parsedUser } from "../../common/GetCurrentUser";
import QuickAddEditMetter from "../Metters/QuickAddEditMetter";
import moment from "moment";
import QuickAddEditSale from "../SalesByGallonPerDay/QuickAddEditSale";
import CalibrationTable from "../Metters/CalibrationTable";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import TotalSaleAndDelivered from "./TotalSaleAndDelivered";

const DashboardOverview = () => {
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const user = parsedUser();
  const [organizationId, setOrganizationId] = useState(user.OrganizationId);
  const { id } = useParams();
  const history = useHistory();
  const [totalMeters, setTotalMeters] = useState(0);
  const SumMeter = (obj) => {
    let count = 0;
    Array.isArray(obj) &&
      obj.forEach((item) => {
        let amount = item.amount - item.previousAmount;
        count += amount;
      });

    setTotalMeters(count);
  };
  const [showCalibration, setShowCalibration] = useState(false);
  const toggleCalibration = () => {
    setShowCalibration(!showCalibration);
  };

  useEffect(() => {
    if (!user) {
      history.push(Routes.SignIn.path);
    }
  }, []);

  return (
    <>
      {showCalibration ? (
        <CalibrationTable toggle={toggleCalibration} show={showCalibration} />
      ) : null}
      <Row className="mx-0">
        <Col className="col-auto">
          <label className="d-inline me-2">Compañia</label>
          <select
            id="organizationId"
            className="form-control d-inline"
            value={organizationId}
            onChange={(e) => {
              //   history.push(Routes.Dashboard.clean + moment(e.target.value).format('YYYY-MM-DD'))
              setOrganizationId(e.target.value);
            }}
          >
            <option value="">-</option>
            <option value="zaboka">Zaboka</option>
            <option value="bazouka1">Bazouka 1</option>
            <option value="bazouka2">Bazouka 2</option>
            <option value="bazouka3">Bazouka 3</option>
            <option value="bazouka4">Bazouka 4</option>
          </select>
        </Col>
        <Col className="col-auto">
          <label className="d-inline me-2">Fecha</label>
          <input
            type="date"
            className="form-control d-inline"
            value={date}
            onChange={(e) => {
              //   history.push(Routes.Dashboard.clean + moment(e.target.value).format('YYYY-MM-DD'))
              setDate(e.target.value);
            }}
          />
        </Col>
        <Col className="col-auto">
          <button
            className="btn btn-primary mt-3"
            onClick={() => {
              history.push(
                Routes.Dashboard.clean + moment(date).format("YYYY-MM-DD")
              );
            }}
          >
            <i className="fa fa-search"></i>
          </button>
        </Col>
        <Col className="col-auto  ms-auto">
          <button
            className="btn btn-secondary"
            onClick={() => toggleCalibration()}
            type="button"
          >
            Mostrar tabla de calibración
          </button>
        </Col>
        <Col xs={12} className="mt-4">
          <Row>
            <Col xs={12} md={12}>
              <QuickAddEditMetter
                date={date}
                SumMetter={SumMeter}
                organizationId={organizationId}
              />
            </Col>

            <Col xs={6}>
              <QuickAddEditSale date={date} organizationId={organizationId} />
            </Col>

            <Col xs={12} md={12}>
              <TotalSaleAndDelivered organizationId={organizationId} />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default DashboardOverview;
